import { render } from "./pc_system_management.vue?vue&type=template&id=29559a91&scoped=true"
import script from "./pc_system_management.vue?vue&type=script&lang=js"
export * from "./pc_system_management.vue?vue&type=script&lang=js"

import "./pc_system_management.vue?vue&type=style&index=0&id=29559a91&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29559a91"]])

export default __exports__